import { defineMessages } from 'react-intl';

export default defineMessages({
    EndorsementPageHeader: {
        id: 'cep.components.sgEndorsementCoveragesPage.Header',
        defaultMessage: 'Your cover options'
    },
    ContinueLabel: {
        id: 'cep.components.sgEndorsementCoveragesPage.ContinueLabel',
        defaultMessage: 'Continue'
    },
    GoBackLabel: {
        id: 'cep.components.sgEndorsementCoveragesPage.GoBackLabel',
        defaultMessage: 'Back'
    },
    BackToMyAccount: {
        id: 'cep.components.sgEndorsementCoveragesPage.BackToMyAccount',
        defaultMessage: 'Back to My Account'
    },
    MakeChangeToCalculate: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.MakeChangeToCalculate',
        defaultMessage: 'Make a change to calculate the new price'
    },
    NewAnnualPrice: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.NewAnnualPrice',
        defaultMessage: 'New Annual Price'
    },
    TotalDueToday: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.TotalDueToday',
        defaultMessage: 'Total due today:'
    },
    TotalRefundToday: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.TotalRefundToday',
        defaultMessage: 'Total refund today:'
    },
    TotalDueZeroToday: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.TotalDueZeroToday',
        defaultMessage: 'Total due today: £0.00'
    },
    NegativePrice: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.NegativePrice',
        defaultMessage: '- {price}'
    }
});
